export enum Operators {
  EQUALS = "==",
  NOT_EQUALS = "!=",
  GREATER_THAN = ">",
  LESS_THAN = "<",
  GREATER_THAN_EQUAL_TO = ">=",
  LESS_THAN_EQUAL_TO = "<=",
  CONTAINS = "@=",
  START_WITH = "_=",
  DOES_NOT_START_WITH = "!_=",
  CASE_INSENSITIVE_STRING_CONTAINS = "@=*",
  CASE_INSENSITIVE_STRING_START_WITH = "_=*",
  CASE_INSENSITIVE_STRING_EQUALS = "==*",
  CASE_INSENSITIVE_STRING_NOT_EQUALS = "!=*",
  CASE_INSENSITIVE_STRING_DOES_NOT_CONTAINS = "!@=*",
  CASE_INSENSITIVE_STRING_DOES_NOT_START_WITH = "!_=*",
}
